var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoUserPermission24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_user_permission24x24",
    transform: "translate(.001)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46738",
    d: "M91.4,8.558A4.271,4.271,0,0,0,94.487,7.3a4.1,4.1,0,0,0,1.28-3.026,4.1,4.1,0,0,0-1.28-3.025,4.431,4.431,0,0,0-6.176,0,4.1,4.1,0,0,0-1.28,3.026A4.1,4.1,0,0,0,88.31,7.3,4.272,4.272,0,0,0,91.4,8.558Zm0,0",
    transform: "translate(-84.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46739",
    d: "M14.963,252.4a10.451,10.451,0,0,0-.146-1.123,8.76,8.76,0,0,0-.28-1.128,5.542,5.542,0,0,0-.47-1.053,3.979,3.979,0,0,0-.708-.912,3.127,3.127,0,0,0-1.017-.632,3.552,3.552,0,0,0-1.3-.232,1.326,1.326,0,0,0-.7.3c-.211.135-.457.293-.733.467a4.227,4.227,0,0,1-.948.413,3.725,3.725,0,0,1-2.32,0,4.218,4.218,0,0,1-.945-.418c-.273-.172-.52-.333-.734-.467a1.323,1.323,0,0,0-.7-.3,3.548,3.548,0,0,0-1.3.232,3.125,3.125,0,0,0-1.017.632,3.978,3.978,0,0,0-.708.912,5.552,5.552,0,0,0-.47,1.053,8.78,8.78,0,0,0-.28,1.128,10.414,10.414,0,0,0-.146,1.123c-.024.34-.036.693-.036,1.049a2.932,2.932,0,0,0,.887,2.232,3.214,3.214,0,0,0,2.284.824h8.652a3.214,3.214,0,0,0,2.284-.824A2.931,2.931,0,0,0,15,253.441C15,253.088,14.987,252.739,14.963,252.4Zm0,0",
    transform: "translate(0 -238.499)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoUserPermission24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_user_permission24x24.6098adcfc10613723ed808b80d4efadb.svg";